export default "__VITE_ASSET__AM1iojfd__"